<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/Boost_Logo_tn.png"
        width="74"
        class="ml-0 mr-4 pr-4"
      /> </template
    >\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>System</strong>
      </b-dropdown-header>
      <b-dropdown-item disabled>
        <i class="fa fa-bell-o" /> Updates
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-tasks" /> Tasks
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Quick Links</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="my_profile">
        <i class="fa fa-user" />Profile
      </b-dropdown-item>
      <!-- <b-dropdown-item disabled>
        <i class="fa fa-wrench" /> Preferences
      </b-dropdown-item> -->

      <!-- <b-dropdown-item @click="open_orders">
        <i class="fa fa-file" /> Open Orders
        <b-badge variant="primary">{{ orderCount }}</b-badge>
      </b-dropdown-item> -->
      <b-dropdown-divider />
      <b-dropdown-item hidden>
        <i class="fa fa-shield" /> Lock Account
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        <i class="fa fa-lock" />
        Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 0
    };
  },
  computed: {
    ...mapState(["n_user", "order"]),
    ...mapGetters("order", ["orderCount"])
  },
  methods: {
    logout() {
      this.$store.dispatch("n_user/logout").then(
        this.$router.push({
          name: "Login"
        })
      );
    },
    open_orders() {
      this.$router.push({
        name: "Shipping"
      });
    },
    async my_profile() {
      if (
        !this.$store.state.n_user.n_users ||
        this.$store.state.n_user.n_users.length == 0
      ) {
        await this.$store.dispatch("n_user/fetchUserGroups");
        await this.$store.dispatch("n_user/fetchUsers");
      }
      this.$store
        .dispatch(
          "n_user/loadUserEdit",
          this.$store.state.n_user.n_current_user.UserProfileID
        )
        .then(
          this.$router.push({
            name: "User"
          })
        );
    }
  }
};
</script>
